import type { LayerDefinition } from '../project/model';
import type { AttributeRule } from '../rules/model';

export type JoinDependencyArea =
  'Display filter' | 'Label field' | 'Label filter' | 'Popup fields' | 'Popup title' | 'Style';

function ruleUsesField(rule: AttributeRule | null, fields: ReadonlySet<string>): boolean {
  if (!rule) return false;
  if (rule.kind === 'condition') return fields.has(rule.field);
  return rule.children.some((child) => ruleUsesField(child, fields));
}

export function joinDependencies(
  layer: LayerDefinition,
  outputFieldIds: readonly string[],
): readonly JoinDependencyArea[] {
  const fields = new Set(outputFieldIds);
  const dependencies: JoinDependencyArea[] = [];
  const classification = layer.style.classification;
  if (classification.mode !== 'single' && fields.has(classification.field))
    dependencies.push('Style');
  if (layer.labels.field && fields.has(layer.labels.field)) dependencies.push('Label field');
  if (ruleUsesField(layer.labels.filter, fields)) dependencies.push('Label filter');
  if (layer.popup.titleField && fields.has(layer.popup.titleField))
    dependencies.push('Popup title');
  if (layer.popup.fields.some((field) => fields.has(field.field)))
    dependencies.push('Popup fields');
  if (ruleUsesField(layer.displayFilter, fields)) dependencies.push('Display filter');
  return dependencies;
}
